import { Controller } from 'stimulus'
import Cleave from 'cleave.js'

export default class extends Controller {

  connect() {
    this.element.value = parseFloat(this.element.value.replace(',', '')).toFixed(2).toLocaleString('en-US', { style: 'decimal' })
    this.cleave = new Cleave(this.element, {
      numeral: true,
      numeralThousandsGroupStyle: 'thousand'
    })
  }

  disconnect() {
    this.cleave.destroy()
  }
}
